module.exports = __webpack_public_path__ + "static/media/img_MRI.308aaf32.jpg";